import { UseMutationResult, useMutation } from "@tanstack/react-query";
import { AxiosError } from "axios";

import axiosInstance from "../../shared/service/axios";
import {
  CustomerAddRequest,
  CustomerAddResponse,
  DeviceListResponse,
  DevicePartListResponse,
} from "./CustomerAdd.constants";
import { Customer } from "../Customer/Customer.constants";

export const useDeviceListMutation = (): UseMutationResult<
  DeviceListResponse,
  AxiosError,
  any
> =>
  useMutation<DeviceListResponse, AxiosError, any>(async () => {
    const { data, status } = await axiosInstance.get("device/");

    return data;
  });

export const useDevicePartListMutation = (): UseMutationResult<
  DevicePartListResponse,
  AxiosError,
  any
> =>
  useMutation<DevicePartListResponse, AxiosError, any>(async () => {
    const { data, status } = await axiosInstance.get("device/part/");
    data.status = status;

    return data;
  });

export const useCustomerAddMutation = (): UseMutationResult<
  Customer,
  AxiosError,
  CustomerAddRequest
> =>
  useMutation<Customer, AxiosError, CustomerAddRequest>(
    async (requestValues: CustomerAddRequest) => {
      const { data, status } = await axiosInstance.post(
        "customer/",
        requestValues
      );
      data.status = status;

      return data;
    }
  );
